import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  // The root entry always lands on the email-only Inform login. /home is
  // deprecated and must not be auto-targeted, even for a persisted session;
  // it stays reachable only by explicit navigation.
  beforeLoad: () => {
    throw redirect({
      to: '/login',
    });
  },
});
